/**
 * POD niches front-end interactions
 * - Filter pills: [data-pod-niche-filter]
 * - List items:   [data-pod-niche-item][data-pod-niche-tag]
 * - Blurb toggle: window.podNichesToggleBlurb (inline onclick on + button)
 */
(function () {
  if (window.__podNichesInteractionsBound) return;
  window.__podNichesInteractionsBound = true;

  let activeFilter = '';

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function setFilter(filter) {
    activeFilter = normalize(filter);

    for (const button of document.querySelectorAll('[data-pod-niche-filter]')) {
      const value = normalize(button.getAttribute('data-pod-niche-filter'));
      const active = activeFilter !== '' && value === activeFilter;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    let visible = 0;
    for (const item of document.querySelectorAll('[data-pod-niche-item]')) {
      const tag = normalize(item.getAttribute('data-pod-niche-tag'));
      const match = activeFilter === '' || tag === activeFilter;
      item.hidden = !match;
      item.classList.toggle('is-filtered-out', !match);
      if (match) visible += 1;
    }

    for (const empty of document.querySelectorAll('[data-pod-niche-empty]')) {
      empty.hidden = visible > 0;
    }
  }

  function toggleBlurb(toggleButton) {
    if (!(toggleButton instanceof HTMLElement)) return false;

    const item = toggleButton.closest('[data-pod-niche-item]');
    if (!(item instanceof HTMLElement)) return false;

    const controlId = toggleButton.getAttribute('aria-controls');
    const blurb =
      (controlId && document.getElementById(controlId)) ||
      item.querySelector('[data-pod-niche-blurb]');

    if (!(blurb instanceof HTMLElement)) return false;

    const willOpen = !item.classList.contains('is-blurb-open');

    item.classList.toggle('is-blurb-open', willOpen);
    blurb.hidden = !willOpen;
    if (willOpen) {
      blurb.removeAttribute('hidden');
    } else {
      blurb.setAttribute('hidden', '');
    }

    toggleButton.classList.toggle('is-open', willOpen);
    toggleButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    return true;
  }

  // Used by inline onclick on the + button (avoids double-binding with delegation).
  window.podNichesToggleBlurb = toggleBlurb;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    // Toggle is handled via inline onclick — do not also handle here.
    if (target.closest('[data-pod-niche-toggle]')) return;

    const button = target.closest('[data-pod-niche-filter]');
    if (!(button instanceof HTMLElement)) return;

    const value = normalize(button.getAttribute('data-pod-niche-filter'));
    if (!value) return;

    event.preventDefault();
    setFilter(activeFilter === value ? '' : value);
  });
})();
